// SponsorshipLevel represents a sponsorship level.
export class SponsorshipLevel {
    constructor(data) {
        this.ID = data.id;
        this.externalID = data.external_id;
        this.name = data.name;
        this.isAvailable = data.is_available;
        this.showEffectLimits = data.show_effect_limits !== undefined ? data.show_effect_limits : true;
        this.price = data.price;
        this.currency = data.currency;
        this.paymentPeriod = data.payment_period;
        this.pricePerYearInUSD = data.price_per_year_in_usd;
        this.freeGenerationPeriod = data.free_generation_period;
        this.freeGenerationSessions = data.free_generation_sessions;
        this.grants = data.grants;
        this.description = data.description || '';
        this.discount3m = data.discount_3m || 0;
        this.discount6m = data.discount_6m || 0;
        this.discount12m = data.discount_12m || 0;
    }
  clone() {
    return new SponsorshipLevel({
      id: this.ID,
      external_id: this.externalID,
      name: this.name,
      is_available: this.isAvailable,
      price: this.price,
      currency: this.currency,
      payment_period: this.paymentPeriod,
      price_per_year_in_usd: this.pricePerYearInUSD,
      free_generation_period: this.freeGenerationPeriod,
      free_generation_sessions: this.freeGenerationSessions,
      grants: this.grants,
      show_effect_limits: this.showEffectLimits,
      description: this.description,
      discount_3m: this.discount3m,
      discount_6m: this.discount6m,
      discount_12m: this.discount12m,
    });
  }
}
